import InputField from 'components/fields/InputField';
import { useEffect, useState } from 'react';

const PrerequisiteInfo = ({ handleChange, formData, setDisable }) => {
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const newErrors = [];

    if (!formData.prerequisites.trim()) {
      newErrors.push('Please fill in the prerequisites field.');
    }

    if (typeof formData.certification !== 'boolean') {
      newErrors.push('Please select whether certification is offered.');
    }

    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [formData, setDisable]);

  const handleCertificationChange = (e) => {
    handleChange({
      target: {
        name: 'certification',
        value: e.target.checked,
      },
    });
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Prerequisites & Certification
      </h4>
      <div className="mt-7">
        <InputField
          extra="mb-3"
          label="Prerequisites"
          placeholder="eg. Basic Programming Knowledge"
          type="text"
          name="prerequisites"
          value={formData.prerequisites}
          onChange={handleChange}
          maxLength={100}
        />
        <div className="mb-3">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="certification"
              checked={formData.certification}
              onChange={handleCertificationChange}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="text-gray-700 dark:text-gray-200">
              Certification Offered
            </span>
          </label>
        </div>
      </div>

      {/* Display errors */}
      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default PrerequisiteInfo;
